import { useQuery, useLazyQuery } from '@apollo/react-hooks';
import { Paper } from '@material-ui/core';
import React, { useEffect } from 'react';
import DetailedTable from '../../components/DetailedTable';
import { Loading } from '../../Loading';
import { ERROR_COUNTS_QUERY, SERVICES_SUMMARY, WORKFLOW_LIST, USER_DETAILS } from '../graphQL/queries';
import columns from './columns';
import moment from 'moment';
import _ from 'lodash';
import Edit from '@jda/lui-common-icon-library/ui/Edit';
import ViewDetails from '@jda/lui-common-icon-library/ui/ViewDetails';
import EditServiceDialog from './EditServiceDialog';
// import PageInfo from './pageInfo';
import toolTipInfo from '../../utils/tooltipInfo.json';

type specObj = {
  workflowName: string;
  workflowCode: string;
  customers: number;
  providers: number;
  certity: boolean;
  errors: string;
};

type responseObj = {
  workflowInfo: specObj[];
};

type workflowInfo = {
  workflowCode: string;
  workflowName: string;
  operations?: any;
  kpiAttributes?: any;
};

type workflowObj = {
  workflow: workflowContentData;
};
type workflowContentData = {
  content: workflowInfo[];
};

const ServiceGrid = () => {
  const [editService, setEditService] = React.useState(false);
  const [workflowCode, SetWorkflowCode] = React.useState<any>('');
  const [userRole, setUserRole] = React.useState('');
  const workflowList = useQuery<workflowObj, {}>(WORKFLOW_LIST, {});
  const { loading: userLoading, data: userData } = useQuery(USER_DETAILS, { fetchPolicy: 'cache-only' });

  useEffect(() => {
    setUserRole(userData?.userProfile?.roles?.[0]);
  }, [userData]);
  const serviceTableActions: any = [
    userRole === 'APP_ADMIN'
      ? {
          icon: () => <Edit data-id="edit-notification" />,
          onClick: (event: any, rowData: any) => handleEditService(rowData)
        }
      : {
          icon: () => <ViewDetails />,
          onClick: (event: any, rowData: any) => handleViewDetails(rowData),
          tooltip: 'View Details',
          position: 'row'
        }
  ];

  const handleViewDetails = (rowData: any) => {
    setEditService(true);
    SetWorkflowCode(rowData.workflowCode);
  };

  const handleEditService = (rowData: any) => {
    setEditService(true);
    SetWorkflowCode(rowData.workflowCode);
  };
  const { loading, data } = useQuery<responseObj, {}>(SERVICES_SUMMARY, {
    skip:
      userData?.userProfile?.roles?.[0] === 'PARTICIPANT_SUPPORT' ||
      userData?.userProfile?.roles?.[0] === 'PARTICIPANT_ADMIN'
        ? true
        : false
  });
  let filterDates: any = {};

  const [getDayErrors, { loading: errorDayCountLoading, data: errorDayCountData }] = useLazyQuery(ERROR_COUNTS_QUERY);
  const [getHourErrors, { loading: errorHourCountLoading, data: errorHourCountData }] = useLazyQuery(
    ERROR_COUNTS_QUERY
  );

  useEffect(() => {
    const date = new Date();
    const todayDate = moment(date).format('YYYY-MM-DD');
    filterDates.startDate = `${todayDate} 00:00:00`;
    filterDates.endDate = `${todayDate} 23:59:59`;

    var tDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    var pDate = new Date(date.getTime() - 1000 * 60 * 60 + date.getTimezoneOffset() * 60000);
    var prev = moment(pDate).format('YYYY-MM-DD hh:mm:ss');
    var current = moment(tDate).format('YYYY-MM-DD hh:mm:ss');

    getDayErrors({ variables: { startDate: `${todayDate} 00:00:00`, endDate: `${todayDate} 23:59:59` } });
    getHourErrors({ variables: { startDate: prev, endDate: current } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCount = (service: string, list: any) => {
    const res = _.filter(list || [], (obj: any) => obj.service === service);
    return res?.[0]?.count || 0;
  };

  useEffect(() => {
    if (errorDayCountData?.errorCounts && errorHourCountData?.errorCounts) {
      (data?.workflowInfo || []).forEach((obj: any) => {
        obj.todayErrorCount = getCount(obj.workflowCode, errorDayCountData.errorCounts);
        obj.lastHourErrorCount = getCount(obj.workflowCode, errorHourCountData.errorCounts);
      });
    }
  }, [data, errorDayCountData, errorHourCountData]);

  const handleEditServiceDialogClose = () => {
    setEditService(false);
  };

  const handleEditServicetDialogSubmit = () => {
    setEditService(false);
  };
  return (
    <div>
      <EditServiceDialog
        dialogOpen={editService}
        handleDialogClose={handleEditServiceDialogClose}
        handleDialogSubmit={handleEditServicetDialogSubmit}
        kpiAttributes={workflowList.data?.workflow?.content || ''}
        workflowCode={workflowCode}
        supportUser={userRole !== 'APP_ADMIN' ? true : false}
      />
      <Paper variant="outlined">
        {(loading && userLoading) || errorDayCountLoading || errorHourCountLoading ? (
          <Loading />
        ) : (
          <DetailedTable
            id="Services"
            title="Services"
            columns={columns}
            data={data?.workflowInfo || []}
            showSelection={false}
            tableActions={serviceTableActions}
            pageLevelInfo={toolTipInfo?.pages?.service}
          />
        )}
      </Paper>
    </div>
  );
};
export default ServiceGrid;
